import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';
 
import { DataService } from '../services/data/data.service';
 
@Injectable({
  providedIn: 'root',
})

export class NotificationsResolverService implements Resolve<any[]> {

  constructor(private dataService: DataService) {
  }
 
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any[]> | Observable<never> {
    return this.dataService.getNotifications().pipe( // workaround
        take(1),
        mergeMap(item => {
          if (item) {
            return of(item);
          } else { // id not found
              return EMPTY;
          }
        })
      );
  }
}